/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const AtomoTab = ({
  active,
  className,
  frameClassName,
  divClassName,
  line = "/img/line-49-1.svg",
  text = "Log in",
}) => {
  return (
    <div
      className={`atomo-tab`}
      style={
        active
          ? { background: "#f9f9f9", borderBottom: "2px solid var(--primario)" }
          : { background: "#ffffff" }
      }
    >
      <div
        className={`frame ${frameClassName}`}
        style={
          active
            ? {
                background: "#f9f9f9",
                borderBottom: "2px solid var(--primario)",
              }
            : { background: "#ffffff" }
        }
      >
        <div className={`log-in active-${active} ${divClassName}`}>{text}</div>
      </div>
    </div>
  );
};

AtomoTab.propTypes = {
  active: PropTypes.bool,
  line: PropTypes.string,
  text: PropTypes.string,
};
